import { Camera } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * The one bubble of the first launch, over the scan button.
 *
 * Warning: exactly one. A sequence of bubbles over every control is a tour
 * nobody reads and everybody dismisses; the single gesture worth pointing at
 * is the one that fills the library, because every other screen is empty
 * until it happens.
 *
 * Warning: it names the gesture, it does not perform it — the button below is
 * still the target, and the bubble must never sit over it. Hence the tail and
 * `bottom-full`.
 *
 * @see docs/features/onboarding.md
 */
export function ScanCoachMark() {
  const { t } = useTranslation('onboarding');

  return (
    <span
      // The tab bar owns the tap; announcing this as a live region would read
      // it out on every navigation. It is a label for the button beneath it.
      aria-hidden
      className="pointer-events-none absolute bottom-full left-1/2 z-20 mb-5 w-52 -translate-x-1/2 rounded-panel bg-accent px-3 py-2.5 text-center text-on-accent shadow-lg shadow-accent/40"
    >
      <span className="flex items-center justify-center gap-1.5 text-xs font-semibold">
        <Camera aria-hidden className="size-3.5" />
        {t('coach.title')}
      </span>

      <span className="mt-0.5 block text-3xs leading-snug text-white/85">
        {t('coach.hint')}
      </span>

      {/* The tail: without it the bubble floats, and what it points at is a
          guess. */}
      <span className="absolute -bottom-1.5 left-1/2 size-3 -translate-x-1/2 rotate-45 bg-accent" />
    </span>
  );
}
